import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { WA_PHYSICS } from '../core/constants';
import { computeSafeSpawnPosition } from './spawnHelper';

/**
 * Nak T2 (GunBound mobile, Shot 2 - Thor's Hammer): a subterranean shell. It
 * arcs normally, then on hitting terrain it BURROWS instead of exploding -
 * keeping its horizontal speed while an upward acceleration curves it back up
 * - and erupts the instant it climbs back out into open air. Lets you hit
 * tanks tucked behind a hill or sitting in a pit. (A burrowing shell that
 * never resurfaces detonates underground after a safety fuse.)
 */
export const WeaponNak: WeaponDefinition = {
  id: 'nak',
  name: 'Nak',
  icon: 'nak.png',
  category: 'thrown',
  maxAmmo: 2,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const speed = (power / 100) * 750;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;
    const spawn = computeSafeSpawnPosition(worm, aimRad, 20, world);

    const shell = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'nak',
      timer: -1,
      windAffected: true,
      explosionRadius: WA_PHYSICS.NAK.EXPLOSION_RADIUS,
      maxDamage: WA_PHYSICS.NAK.MAX_DAMAGE,
      ownerId: worm.id,
    });

    return { success: true, entities: [shell] };
  },
};
